module.exports = "/static/assets/2ccece2ca30002d265c673e1445b59c2.png";